import { render } from "./CatalogModal.vue?vue&type=template&id=3bd52d8b&scoped=true"
import script from "./CatalogModal.vue?vue&type=script&lang=js"
export * from "./CatalogModal.vue?vue&type=script&lang=js"

import "./CatalogModal.vue?vue&type=style&index=0&id=3bd52d8b&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd52d8b"]])

export default __exports__